import { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import config from '../../../../config';
import { useNavigate } from 'react-router-dom';
import { fetchCuestionarioById } from '../../api/cuestionariosApi';

const parseRespuestas = (value) => {
  if (!value) return {};
  if (typeof value === 'string') {
    try { return JSON.parse(value); } catch (_e) { return {}; }
  }
  return typeof value === 'object' ? value : {};
};

const CUESTIONARIO_VENT = 2;

export const useCuestionarioVentForm = ({ idPaciente, idCuestionario }) => {
  const cookies = new Cookies();
  const token = cookies.get('TOKEN');
  const API_URL = `https://${config.BACKEND}:${config.PORT}/cuestionario`;
  const navigate = useNavigate();
  const isEdit = Boolean(idCuestionario);

  const [fumador, setFumador] = useState('');
  const [cigarrosDia, setCigarrosDia] = useState('');
  const [aniosDeshabituacion, setAniosDeshabituacion] = useState('');
  const [ejercicio, setEjercicio] = useState('');
  const [actividadFisica, setActividadFisica] = useState('');
  const [pef, setPef] = useState('');
  const [openGood, setOpenGood] = useState(false);

  useEffect(() => {
    if (!isEdit) return;
    fetchCuestionarioById(idCuestionario, idPaciente)
      .then((data) => {
        const r = parseRespuestas(data?.respuestas);
        setFumador(r.fumador || '');
        setCigarrosDia(r.cigarrosDia || '');
        setAniosDeshabituacion(r.aniosDeshabituacion || '');
        setEjercicio(r.ejercicio || '');
        setActividadFisica(r.actividadFisica || '');
        setPef(r.pef || '');
      })
      .catch((err) => console.error('Error fetching cuestionario VENT:', err));
  }, [isEdit, idCuestionario, idPaciente]);

  const guardarDatos = async () => {
    const datos = {
      fumador,
      cigarrosDia: fumador === 'si' ? cigarrosDia : null,
      aniosDeshabituacion: fumador === 'lo-fue' ? aniosDeshabituacion : null,
      ejercicio,
      actividadFisica: ejercicio === 'si' ? actividadFisica : null,
      pef,
    };
    const headers = { Authorization: `Bearer ${token}` };
    try {
      if (isEdit) {
        try {
          await axios.put(`${API_URL}/${idCuestionario}`, datos, { headers });
        } catch (err) {
          if (err.response?.status === 404) {
            await axios.post(`${API_URL}/${idCuestionario}`, datos, { headers });
          } else throw err;
        }
      } else {
        await axios.post(`${API_URL}/${idPaciente}/${CUESTIONARIO_VENT}`, datos, { headers });
      }
      setOpenGood(true);
      setTimeout(() => navigate(isEdit ? -1 : `/paciente/${idPaciente}`), 1500);
    } catch (err) {
      console.error('Error guardando cuestionario VENT:', err);
    }
  };

  return {
    fumador, setFumador,
    cigarrosDia, setCigarrosDia,
    aniosDeshabituacion, setAniosDeshabituacion,
    ejercicio, setEjercicio,
    actividadFisica, setActividadFisica,
    pef, setPef,
    openGood, setOpenGood,
    isEdit,
    guardarDatos,
  };
};
